import $ from "jquery";

$(document).ready(function() {
  $('a[href="#"]').click(function(e) {
    e.preventDefault();
  });

  $("body").on("click", ".shared-block-item", function(event) {
    event.preventDefault();
    event.stopPropagation();

    var a = document.createElement("a");
    a.target = "_blank";
    a.href = $(this).attr("data-href");
    a.click();
  });

  $(".header-nav-trigger").on("click", function() {
    $(".header").toggleClass("active");
  });

  $(".close-brand-modal").on("click", function() {
    $(".container-slider-extras,.container-slide-extra").removeClass("active");
  });

  $(".toggle-fullscreen").on("click", function() {
    $(".car-item-slider").toggleClass("full");
  });
});
